module.exports = "<div id={{calenderId}}></div>"